import axios from "@/config/axios";

const initialState = () => {
  return {
    networkPayors: null,
    networkPayorsLoading: false,
  };
};

const state = initialState();

const getters = {
  getNetworkPayors: (state) => state.networkPayors,
  getNetworkPayorsLoading: (state) => state.networkPayorsLoading,
};

const mutations = {
  setNetworkPayors(state, data) {
    state.networkPayors = data;
  },
  setNetworkPayorsLoading(state, data) {
    state.networkPayorsLoading = data;
  },
  reset: (state) => {
    const initial = initialState();
    Object.keys(initial).forEach((key) => {
      state[key] = initial[key];
    });
  },
};

const actions = {
  // Payor contracts for the lab the signed-in user belongs to. The lab is taken
  // from the auth token, so no lab id is sent.
  fetchNetworkPayors: async ({ commit, dispatch }, params) => {
    try {
      commit("setNetworkPayorsLoading", true);
      await dispatch("errors/clear", [], { root: true });

      const response = await axios.get("/network-payors", { params });

      commit("setNetworkPayors", response.data.data);
    } catch (error) {
      commit("setNetworkPayors", null);
      if (error.response) {
        await dispatch("errors/errorResponse", error.response, { root: true });
      }
    } finally {
      commit("setNetworkPayorsLoading", false);
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
